import React, { useEffect, useState } from "react";
import thankyouIcon from '../assets/thankyou.svg'
import { getUrlParams } from "../common";

const ThankYou = () => {

    const [mode, setMode] = useState('LLN & Evidence of Identity Form')

    useEffect(() => {
        const params = getUrlParams()
        if (params.id) {
            setMode('Declaration Form')
        }
    }, [])


    return (<>
        <div style={{ margin: '20px auto', maxWidth: '700px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img src={thankyouIcon} style={{ width: '60px', height: '60px' }} />
            <h1 style={{ textAlign: 'center' }}>Your {mode} has been submitted successfully! Please wait for instructions from your trainer.</h1>
            {mode === 'Declaration Form' && <p>Thank you for sharing your views.</p>}
        </div>
    </>)
}

export default ThankYou